export default {
    REQUEST: 'REQUEST_TEXTS',
    RECEIVE: 'RECEIVE_TEXTS',
    FETCH_ERROR: 'FETCH_ERROR_TEXTS'
};
